import { Component, OnInit, Input } from '@angular/core';
import { PatientComponent } from '../patient/patient.component';

@Component({
  selector: 'app-patient-insurance',
  templateUrl: './patient-insurance.component.html',
  styleUrls: ['./patient-insurance.component.scss']
})
export class PatientInsuranceComponent extends PatientComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  insuranceSelected(event) {
    console.log('insurance selected', event);
  }
}
